module.exports = __webpack_public_path__ + "img/praxis-lambrette-supervision.7ba9820c.png";